import { defineMessages } from "react-intl";

const messages = defineMessages({
    firstName: {
        id: "account.firstName",
    },
    lastName: {
        id: "account.lastName",
    },
    email: {
        id: "account.email",
    },
    phone: {
        id: "choir.position.application.phone"
    },
    send: {
        id: "general.send"
    },
    title: {
        id: "choir.applicationForm",
    },
    voice: {
        id: "choir.voice",
    },
});

export default messages;
